export default {
  'zh-CN': {
    to: '至',
    forever: '永久',
    startDate: '开始日期',
    endDate: '结束日期',
    startMonth: '开始月份',
    endMonth: '结束月份'
  },
  'en': {
    to: 'To',
    forever: 'Permanent',
    startDate: 'Start date',
    endDate: 'End date',
    startMonth: 'Start month',
    endMonth: 'End month'
  }
}
